import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {api} from "../../../app/api";

export const eventsList = createAsyncThunk(
    'events/recieveEvents',
    async ({token}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`,
        }
        const response = await api.get('/draws')
        return response.data
    }
)

export const registrateTeam = createAsyncThunk(
    'event/registrateTeam',
    async ({token, contestId, lead, purpose_id, city, full_name}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`
        }
        const response = await api.post(`/contests/${contestId}/register`, {lead, purpose_id, city, full_name})
        return response.data
    }
)

export const getResult = createAsyncThunk(
    'events/getResults',
    async ({token,contest}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`
        }
        const response = await api.get(`/contests/${contest}/results`)
        return response.data
    }
)
export const sendEventData = createAsyncThunk(
    'events/sendEventData',
    async ({token, formData, contestID, purpose_id}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`,
            'content-type': 'multipart/form-data'
        }
        const response = await api.post(`/contests/${contestID}/send-media`,  formData  )
        return response.data
    }
)

export const fetchContest = createAsyncThunk(
    'events/fetchContest',
    async ({token, contest}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`,
        }
        const response = await api.get(`/contests/${contest}`)
        return response.data
    }
)

export const fetchContests = createAsyncThunk(
    'events/fetchContest',
    async ({token}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`,
        }
        const response = await api.get(`/contests`)
        return response.data
    }
)

export const fetchAllVideos = createAsyncThunk(
    'events/fetchAllVideos',
    async ({token, contestID}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`,
        }
        const response = await api.get(`/contests/${contestID}/teams/vote-list`)
        return response.data
    }
)

export const sendVote = createAsyncThunk(
    'events/sendVote',
    async ({token, contestID, team}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`,
        }
        const response = await api.post(`contests/${contestID}/teams/${team}/vote`)
        return response.data
    }
)

export const fetchMyTeam = createAsyncThunk(
    'events/sendVote',
    async ({token, contest}) => {
        api.defaults.headers = {
            Authorization: `Bearer ${token}`,
        }
        const response = await api.get(`contests/${contest}/teams/user-team`)
        return response.data
    }
)

const eventSlice = createSlice({
    name: 'event',
    initialState: {
        eventLoading: false,
        events: [],
        showTable: false,
        tableRef: null,
        eventFinished: false,
        userNumberLoading: false,
        userNumber: '',
        contestId: '',
        contestVideos: [],
        myTeam: '',
        city: '',
        contests: '',
        contest: '',
        cityLoading: '',
        error: {
            failed: false,
            message: null,
        },
        results: [],
        resultsLoading: false
    },
    reducers: {
        showEventResult(state) {
            state.showTable = !state.showTable
        },
        setRef(state, action) {
            state.tableRef = action.payload
            state.eventFinished = action.payload
        },
        setContestId(state,action) {
            state.contestId = action.payload
        }
    },

    extraReducers: {
        [eventsList.pending]: (state) => {
            state.eventLoading = true
            state.error.failed = false
            state.error.message = null
        },
        [eventsList.fulfilled]: (state, action) => {
            state.eventLoading = false
            state.events = action.payload
        },
        [eventsList.rejected]: (state, action) => {
            state.eventLoading = false
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [sendEventData.pending]: (state) => {
            state.userNumberLoading = true
            state.error.failed = false
            state.error.message = null
        },
        [sendEventData.fulfilled]: (state, action) => {
            state.userNumberLoading = false
            localStorage.setItem('user_number', action.payload.user_number)
            state.userNumber = action.payload.user_number
        },
        [sendEventData.pending]: (state, action) => {
            state.userNumberLoading = false
            state.error.failed = true
            state.error.message = action.payload
        },
        [getResult.pending]: (state) => {
            state.resultsLoading = true
            state.error.failed = false
            state.error.message = null
        },
        [getResult.fulfilled]: (state, action) => {
            state.resultsLoading = false
            state.results = action.payload
        },
        [getResult.rejected]: (state, action) => {
            state.error.failed = true
            state.error.message = action.payload
        },
        [fetchContest.pending]: (state) => {
            state.loading = true
            state.error.failed = false
            state.error.message = null
        },
        [fetchContest.fulfilled]: (state, action) => {
            state.contest = action.payload
            console.log(action.payload)
        },
        [fetchContest.rejected]: (state, action) => {
            state.error.failed = true
            state.error.message = action.payload
        },
        [fetchContests.pending]: (state) => {
            state.loading = true
            state.error.failed = false
            state.error.message = null
        },
        [fetchContests.fulfilled]: (state, action) => {
            state.contests = action.payload
            if (!state.contestId) {
                state.contestId = action.payload[0]?.id
            }
        },
        [fetchContests.rejected]: (state, action) => {
            state.error.failed = true
            state.error.message = action.payload
        },
        [registrateTeam.pending]: (state) => {
            state.cityLoading = true
            state.error.failed = false
            state.error.message = null
        },
        [registrateTeam.fulfilled]: (state, action) => {
            state.city = action.payload
        },
        [getResult.pending]: (state, action) => {
            state.results = []
            state.error.failed = true
            state.error.message = action.payload
        },
        [fetchAllVideos.pending]: (state) => {
            state.eventLoading = true
            state.error.failed = false
            state.error.message = null
        },
        [fetchAllVideos.fulfilled]: (state, action) => {
            state.eventLoading = false
            state.contestVideos = action.payload
        },
        [fetchAllVideos.rejected]: (state, action) => {
            state.eventLoading = false
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [fetchMyTeam.pending]: (state) => {
            state.eventLoading = true
            state.error.failed = false
            state.error.message = null
        },
        [fetchMyTeam.fulfilled]: (state, action) => {
            state.eventLoading = false
            state.myTeam = action.payload
        },
        [fetchMyTeam.rejected]: (state, action) => {
            state.eventLoading = false
            state.error.message = action.payload;
            state.error.failed = true;
        },
    }
})

export const {showEventResult, setRef, setContestId} = eventSlice.actions

export default eventSlice.reducer
